(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/racing/pix-banner/assets/helpers/handlebars-helper.js') >= 0) return;  svs.modules.push('/components/racing/pix-banner/assets/helpers/handlebars-helper.js');

'use strict';

function registerHelpers(hbs, racingCommon) {
  hbs.registerHelper('getPixDataTrackName', product => {
    const gameType = racingCommon.constants.subProductIdToGameType[product.toUpperCase()];
    const productUrlName = racingCommon.strings.getProductUrlName(gameType);
    return "pix-".concat(productUrlName);
  });
}
if (typeof exports === 'object') {
  registerHelpers(require('hbs'), require('@svenskaspelab/trinidad-core').core.components.require('racing', 'common'));
} else {
  registerHelpers(Handlebars, svs.racing.common);
}

 })(window);